import { Base } from './_base';
import { merge_by_template } from '@shared/helpers/collections';

export class TimeFrontend extends Base {
  constructor(item) {
    super(item);

    this.data = merge_by_template(this.data, {
      params: {
        time_condition_id: null
      },
      options: {
        yes: null,
        no: null
      }
    });
  }
}
